import { getCookieConsent } from 'providers/CookieConsentProvider';
import { WlWindow } from 'typings/globals/cordova';

declare const window: WlWindow;

function init() {
  console.log('Facebook Ads init');

  const FACEBOOK_PIXEL_ID =
    ENVIRONMENT === 'production' ? '785393515812764' : '1000000000000';

  const scriptSetupElement = document.createElement('script');
  scriptSetupElement.innerHTML = `
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${FACEBOOK_PIXEL_ID}');
  `;
  document.head.appendChild(scriptSetupElement);

  const { advertisement } = getCookieConsent();
  if (advertisement) {
    window.fbq?.('consent', 'grant');
  } else {
    window.fbq?.('consent', 'revoke');
  }
}

export default {
  init,
};
